import React from "react";
import { COMPLAINT_SOURCE_OPTIONS, COMPLAINT_STATUS_OPTIONS } from "../../../Utils/Constants/Constants";

function ComplaintFilters({ source = "", status = "", onChange }) {
  const handleSourceChange = (e) => {
    if (onChange) onChange({ source: e.target.value, status });
  };

  const handleStatusChange = (e) => {
    if (onChange) onChange({ source, status: e.target.value });
  };

  return (
    <div className="cf-row" data-cy="complaint-filters">
      <select
        className="dr-select"
        data-cy="cf-source"
        value={source}
        onChange={handleSourceChange}
      >
        {COMPLAINT_SOURCE_OPTIONS.map((opt) => (
          <option key={opt.key} value={opt.key}>{opt.label}</option>
        ))}
      </select>
      <select
        className="dr-select"
        data-cy="cf-status"
        value={status}
        onChange={handleStatusChange}
      >
        {COMPLAINT_STATUS_OPTIONS.map((opt) => (
          <option key={opt.key} value={opt.key}>{opt.label}</option>
        ))}
      </select>
    </div>
  );
}

export default ComplaintFilters;
